export default {
    common: {
        title: 'Contenu IA',
        socialPlanner: 'Planificateur social',
        blog: 'Blog',
        funnel: 'Funnel',
        website: 'Site web',
        mediaLibrary: 'Médiathèque',
        email: 'Email',
        words: 'Mots',
        variations: 'Variations',
        thisIsPaidService: 'Cette fonctionnalité est un service payant et entraînera des frais en fonction de votre utilisation',
        all: 'Tutti',
    },
};
